import { firebaseDb as db } from '../firebase'

import { asyncRequest, asyncSuccess, asyncFail, cleanMessages, storeCompaniesRoles } from '../actions'
import { Roles } from '../config'

const uuid = require('uuid/v1')

// Only SuperAdmin, loads all companies
export const fetchCompanies = (userId, isSuperAdmin) => {
  return dispatch => {
    dispatch(asyncRequest('fetchCompanies'))

    let companiesRef = null
    if (isSuperAdmin) {
      // superadmin- fetch all Companies
      companiesRef = db.collection('companies')
    } else {
      // normal user - fetch only Companies I am assigned to
      companiesRef = db.collection('companies').where(`users.${userId}.role`, '<=', Roles.COMPANY.USER)
    }

    companiesRef
      .get()
      .then(companiesSnap => {
        const companies = {}
        const companiesRoles = {}

        companiesSnap.forEach(doc => {
          companies[doc.id] = doc.data()
          companies[doc.id].id = doc.id

          companiesRoles[doc.id] = isSuperAdmin ? 0 : doc.data().users[userId].role
        })
        dispatch(asyncSuccess('fetchCompanies', { companies }, null))
        dispatch(storeCompaniesRoles(companiesRoles))
      })
      .catch(error => {
        console.log(error)
        dispatch(asyncFail('fetchCompanies', error.code))
        dispatch(cleanMessages())
      })
  }
}

export const addCompany = companyName => {
  const companyId = uuid()
  const company = {
    name: companyName,
    users: {}
  }

  const newCompany = {}
  newCompany[companyId] = company

  return dispatch => {
    dispatch(asyncRequest('addCompany'))

    db
      .collection('companies')
      .doc(companyId)
      .set(company)
      .then(() => {
        dispatch(asyncSuccess('addCompany', { company: newCompany }, 'Company created'))
        dispatch(cleanMessages())
      })
      .catch(error => {
        console.log(error)
        dispatch(asyncFail('addCompany', error.code))
        dispatch(cleanMessages())
      })
  }
}

export const editCompanyGeneral = (companyId, fields) => {
  return dispatch => {
    dispatch(asyncRequest('editCompanyGeneral'))

    const projectRef = db.collection('companies').doc(companyId)

    projectRef
      .update(fields)
      .then(() => {
        dispatch(asyncSuccess('editCompanyGeneral', { companyId, fields }, 'Company settings saved successfully'))
      })
      .catch(error => {
        console.log(error)
        dispatch(asyncFail('editCompanyGeneral', error.message))
        dispatch(cleanMessages())
      })
  }
}

export const editCompanyUsers = (companyId, users) => {
  return dispatch => {
    dispatch(asyncRequest('editCompanyUsers'))

    const projectRef = db.collection('companies').doc(companyId)

    if (!users) {
      users = null
    }

    projectRef
      .update({ users })
      .then(() => {
        dispatch(asyncSuccess('editCompanyUsers', { companyId, users }, 'Company users saved successfully'))
      })
      .catch(error => {
        console.log(error)
        dispatch(asyncFail('editCompanyUsers', error.message))
        dispatch(cleanMessages())
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/companies.js